var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhite3Dot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7996 0.395508C12.6833 0.395508 13.3996 1.11185 13.3996 1.99551V2.00511C13.3996 2.88876 12.6833 3.60511 11.7996 3.60511C10.916 3.60511 10.1996 2.88876 10.1996 2.00511V1.99551C10.1996 1.11185 10.916 0.395508 11.7996 0.395508Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99961 0.395508C7.88326 0.395508 8.59961 1.11185 8.59961 1.99551V2.00511C8.59961 2.88876 7.88326 3.60511 6.99961 3.60511C6.11595 3.60511 5.39961 2.88876 5.39961 2.00511V1.99551C5.39961 1.11185 6.11595 0.395508 6.99961 0.395508Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19961 0.395508C3.08326 0.395508 3.79961 1.11185 3.79961 1.99551V2.00511C3.79961 2.88876 3.08326 3.60511 2.19961 3.60511C1.31595 3.60511 0.599609 2.88876 0.599609 2.00511L0.599609 1.99551C0.599609 1.11185 1.31595 0.395508 2.19961 0.395508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite3Dot);
export default __webpack_public_path__ + "static/media/white3dot.4d7a7e2f2b2af02fb97aa8829e51086c.svg";
export { ForwardRef as ReactComponent };